/**
 * Polls until the workspace's AppSumo tier shows up, or the timeout passes.
 *
 * /appsumo/oauth/complete can return before the tier is applied: a brand-new
 * workspace's DB row comes from the async Clerk organization.created webhook,
 * and the backend applies the tier once that row exists (a few seconds
 * later). Opening the dashboard before then loads and caches the Free plan.
 *
 * A failed read counts as "not yet" (the row may not exist). Returns true
 * once the tier is seen, false on timeout so the caller can carry on anyway.
 */
export async function waitForAppSumoTier(
  readTier: () => Promise<number | null>,
  { intervalMs = 1000, timeoutMs = 15000 } = {}
): Promise<boolean> {
  const deadline = Date.now() + timeoutMs;
  for (;;) {
    try {
      if ((await readTier()) != null) return true;
    } catch {
      // Not ready yet; poll again.
    }
    if (Date.now() >= deadline) return false;
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
}
